/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const mapLanguage = (preference) => {
  switch (preference) {
    case "english":
    case "en":
      return "en";
    case "spanish":
    case "es":
      return "es";
    default:
      return "en";
  }
};
